import React from "react";
import { Link } from "react-router-dom";
import { BRAND } from "@/lib/brand";
import { useCookieConsent } from "@/hooks/useCookieConsent";

export function SiteFooter({ lang = "en" }: { lang?: "en" | "fr" }) {
  const { resetConsent } = useCookieConsent();
  
  return (
    <footer className="mt-16" style={{ backgroundColor: BRAND.navy }}>
      <div className="mx-auto max-w-7xl px-4 py-10 text-sm" style={{ color: BRAND.silver }}>
        <div className="footer-logo-wrap mb-8">
          <Link to="/">
            <img src="/noBgColor.png" alt="AcquizGroup" className="ag-logo-footer" />
          </Link>
        </div>
        <div className="grid md:grid-cols-5 gap-8">
          <div>
            <h3 className="font-bold text-base uppercase tracking-wide border-b border-white/30 pb-2 mb-3" style={{ color: BRAND.goldEnd }}>
              {lang === "fr" ? "À propos" : "About"}
            </h3>
            <p className="mt-2 text-xs">
              {lang === "fr"
                ? "Nous facilitons les partenariats, la transmission d'entreprises et la structuration opérationnelle."
                : "We facilitate partnerships, business transmission, and operational structuring."}
            </p>
          </div>
          <div>
            <h3 className="font-bold text-base uppercase tracking-wide border-b border-white/30 pb-2 mb-3" style={{ color: BRAND.goldEnd }}>{lang === "fr" ? "Transactions" : "Transactions"}</h3>
            <ul className="mt-2 space-y-2">
              <li>
                <Link to="/landing/sellers" className="hover:underline">
                  {lang === "fr" ? "Vendre" : "Sell"}
                </Link>
              </li>
              <li>
                <Link to="/landing/buyers" className="hover:underline">
                  {lang === "fr" ? "Acheter" : "Buy"}
                </Link>
              </li>
              <li>
                <Link to="/register/brokers" className="hover:underline">
                  {lang === "fr" ? "Créer un listing" : "Create Listing"}
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="font-bold text-base uppercase tracking-wide border-b border-white/30 pb-2 mb-3" style={{ color: BRAND.goldEnd }}>{lang === "fr" ? "Alliés clés" : "Key Allies"}</h3>
            <ul className="mt-2 space-y-2">
              <li>
                <Link to="/register/consultant" className="hover:underline">
                  {lang === "fr" ? "Consultants" : "Consultants"}
                </Link>
              </li>
              <li>
                <Link to="/landing/partners" className="hover:underline">
                  {lang === "fr" ? "Nos experts" : "Our Experts"}
                </Link>
              </li>
              <li>
                <Link to="/landing/lenders" className="hover:underline">
                  {lang === "fr" ? "Prêteurs" : "Lenders"}
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="font-bold text-base uppercase tracking-wide border-b border-white/30 pb-2 mb-3" style={{ color: BRAND.goldEnd }}>{lang === "fr" ? "Ressources" : "Resources"}</h3>
            <ul className="mt-2 space-y-2">
              <li>
                <Link to="/listings" className="hover:underline">
                  Deal Monitor
                </Link>
              </li>
              <li>
                <Link to="/blog" className="hover:underline">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/resources/e-learning" className="hover:underline">
                  E-Learning
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="font-bold text-base uppercase tracking-wide border-b border-white/30 pb-2 mb-3" style={{ color: BRAND.goldEnd }}>{lang === "fr" ? "Contact" : "Contact"}</h3>
            <p className="mt-2 text-xs">
              {lang === "fr"
                ? "Contactez‑nous pour discuter de vos projets d'acquisition ou de transmission."
                : "Contact us to discuss your acquisition or transmission projects."}
            </p>
            <Link
              to="/contact"
              className="inline-block mt-3 rounded-md text-sm font-semibold px-3 py-1"
              style={{ background: `linear-gradient(90deg, ${BRAND.goldStart}, ${BRAND.goldEnd})`, color: "#1f2937" }}
            >
              {lang === "fr" ? "Contacter l'équipe" : "Contact The Team"}
            </Link>
          </div>
        </div>
        <hr className="my-6 border-white/20" />
        <div className="flex flex-wrap justify-center gap-4 text-xs mb-4">
          <Link to="/terms" className="hover:underline">
            {lang === "fr" ? "Termes et Conditions" : "Terms & Conditions"}
          </Link>
          <span className="text-white/40">|</span>
          <Link to="/privacy" className="hover:underline">
            {lang === "fr" ? "Politique de confidentialité" : "Privacy Policy"}
          </Link>
          <span className="text-white/40">|</span>
          <Link to="/cookies" className="hover:underline">
            {lang === "fr" ? "Politique des cookies" : "Cookie Policy"}
          </Link>
          <span className="text-white/40">|</span>
          <button 
            onClick={resetConsent} 
            className="hover:underline text-left"
          >
            {lang === "fr" ? "Gérer les cookies" : "Manage Cookies"}
          </button>
        </div>
        <div className="text-center text-xs">
          © 2026 AcquizGroup. {lang === "fr" ? "Tous droits réservés." : "All rights reserved."}
        </div>
      </div>
    </footer>
  );
}
